import type { TurnaroundRange } from '@rpl/pricing';
import { CartModal } from './CartModal';
import { turnaroundLabel } from '../../lib/turnaround';

/**
 * Pre-checkout turnaround acknowledgment (owner 2026-07-31).
 *
 * One line, one number: the SLOWEST family in the cart sets the estimate, and
 * no product families are named — reading three rows of mostly-irrelevant
 * detail at the moment of payment is how people stop reading at all.
 *
 * The primary button IS the checkout trigger (net one extra tap, never a
 * dialog you dismiss and then click Checkout again), and CartScreen shows this
 * once per session. This dialog exists because Shopify's own checkout can only
 * show one per-location pickup string for every product type; this is the last
 * surface we control before that.
 *
 * Deliberate policy note: this reverses "no turnaround promises anywhere"
 * (staff round 2026-07-11) — owner decision 2026-07-31. The wording keeps the
 * NOTIFICATION as the real go-signal.
 */
export function TurnaroundDialog({
  range,
  onConfirm,
  onClose,
}: {
  range: TurnaroundRange;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <CartModal onClose={onClose} title="Before you check out" width={430}>
      <div className="turnd">
        <h3 className="turnd__title">
          Your order will be ready in about{' '}
          <span className="turnd__days">{turnaroundLabel(range)}</span>
        </h3>
        <p className="turnd__body">
          We&rsquo;ll text you the moment it&rsquo;s ready to collect. If it&rsquo;s being
          shipped, we&rsquo;ll send tracking as soon as it leaves the lab.
        </p>
        <button type="button" className="btn btn--gold turnd__cta" onClick={onConfirm}>
          Continue to secure checkout →
        </button>
      </div>
    </CartModal>
  );
}
